export class Pagination<T>{
    public data : T;
    public itemsPerPage : number;
    public currentPage : number;
    public totalRecords : number;
}